// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1rvHF","footer":"ModalInfo_footer__3AxTl"};